/**
 * This class returns all of the stripe subscription attached to a certain user
 */
import Result from './Result';

class LogoutResult extends Result {
	private _status: boolean;

	/**
	 * @param success whether the request was successfully
	 * @param message contains the error if the request was unsuccessful
	 * @param status a boolean value
	 */
	constructor(
		success: boolean,
		message: string,
		status: boolean
	) {
		super(success, message);
		this._status = status;
	}

	get status(): boolean {
		return this._status;
	}
}

export default LogoutResult;
